<template>
  <el-dialog
    title="下载发料清单"
    :visible.sync="dialogVisible"
    width="500px"
    custom-class="down_dialog_wrap"
    :before-close="handleClose"
    :append-to-body="true"
  >
    <ul class="down_list_cls" v-loading="loading">
      <li class="m_td m_th">
        <div>PCBA名称</div>
        <div>BOM状态</div>
        <div>操作</div>
      </li>
      <li class="m_td" v-for="(val,index) in list" :key="index">
        <div>{{val.pcbaName}}</div>
        <div>{{val.bomTypeStatusLabel}}</div>
        <div class="downBtn" @click="downFile(val.demandPcbaId)" v-if="val.isDownloadMaterial">下载</div>
        <div v-else>-</div>
      </li>
    </ul>
  </el-dialog>
</template>
<script>
import {downloadMaterialsList} from "@@/api/pcba.js"
import CONFIG from '@@/config'
import { getToken } from "@@/utils/auth";
import { downloadFile } from '@@/utils/utils'
export default {
  data() {
    return {
      dialogVisible: false,
      loading:false,
      demandSn:'', //订单号
      list:[]
    };
  },
  methods: {
     handleClose() {
      this.dialogVisible = false;
    },
    open(demandSn){
        this.dialogVisible= true;
        this.loading = true
        this.demandSn = demandSn;
        this.getDownList()
    },
    getDownList(){
        downloadMaterialsList({
            demandSn:this.demandSn
        }).then(res=>{
            this.list = res.result || []
        }).finally(()=>{
            this.loading = false
        })
    },
    downFile(demandPcbaId){
         downloadFile(
        `${CONFIG.HQPCBA_HOST}/pcba/app/demand/downloadMaterials?demandSn=${
          this.demandSn
        }&token=${getToken()}&demandPcbaId=${demandPcbaId}`,
        `待发料清单-${this.demandSn}`
      ); 
    }
   
  },
};
</script>
<style lang="scss" scoped>
    ::v-deep{
        .down_dialog_wrap{
            padding-bottom: 30px;
        }
    }
    .down_list_cls{
        border-top: 1px  solid #f2f2f2;
        border-right: 1px  solid #f2f2f2;
        li{
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            &>div{
                flex: 1;
                text-align: center;
                line-height: 30px;
                color: #7F7F7F;
                border-left: 1px solid #f2f2f2;
                border-bottom: 1px solid #f2f2f2;
            }
            &.m_th{
                background: #f8f9fa;
                color: #7F7F7F;
                font-weight: bold;
            }
            .downBtn{
                cursor: pointer;
                color: #1E6DF9;
            }
        }
    }
</style>
